module.exports = __webpack_public_path__ + "img/like-icon.fada6c3f.png";